































































































































































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { AssetType, TideAsset } from '../../../types/interfaces'
import Icon from '../../shared/Icon/Icon.vue'
import Card from '../Card.vue'
import YouTubePlayer from '../../shared/YouTubePlayer.vue'
import { imageViewAgainPath, videoViewAgainPath, xClosePath } from '../../../assets/svg/paths'

@Component({
  components: {
    Icon,
    Card,
    YouTubePlayer
  }
})
export default class Asset extends Vue {
  @Prop({ default: null }) questionType!: string | null
  @Prop({ default: null }) asset!: TideAsset
  @Prop({ default: false }) youTubeIframeApiReady!: boolean

  @Ref('assetContent') assetContentRef?: HTMLParagraphElement

  AssetType = AssetType
  expanded = false
  windowWidth = window.innerWidth
  youtubePlayerStateOverride = false
  viewedInitially = this.asset.viewed

  imageViewAgainPath = imageViewAgainPath
  videoViewAgainPath = videoViewAgainPath
  xClosePath = xClosePath

  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }

  get isMobile () {
    return this.windowWidth < 769
  }

  get isMatrix () {
    return this.questionType === 'matrix-likert'
  }

  get isDescription () {
    return this.questionType && ['description', 'variant'].includes(this.questionType)
  }

  get customQuestionClasses () {
    return {
      viewed: !this.isMobile && this.viewedInitially,
      matrix: this.isMatrix,
      description: this.isDescription,
      expanded: this.expanded
    }
  }

  get promptText () {
    if (this.asset.type === AssetType.IMAGE) {
      return `View image before proceeding`
    } else if (this.asset.type === AssetType.VIDEO) {
      return `View video before proceeding`
    }
  }

  emitAssetViewed () {
    if (!this.asset) {
      console.error('Cannot emit asset viewed event; there is no asset')
      return
    }
    this.$emit('asset-viewed')
  }

  viewMediaAsset () {
    window.addEventListener('keydown',  this.assetKeyHandler)
    this.emitAssetViewed()
    if (this.asset.type === AssetType.IMAGE || this.asset.type === AssetType.TEXT) {
      this.expanded = true
    } else if (this.asset.type === AssetType.VIDEO) {
      this.youtubePlayerStateOverride = true

      if (this.isMobile && this.asset.viewed) {
        this.expanded = true
      }
    }
  }

  toggleTextAsset () {
    this.emitAssetViewed()
    this.expanded = !this.expanded
    if (this.expanded && this.assetContentRef) {
      this.assetContentRef.style.height = this.assetContentRef?.scrollHeight + 'px'
    } else if (this.assetContentRef) {
      this.assetContentRef.style.height = '0'
    }
  }

  assetKeyHandler(e: KeyboardEvent ) {
    if (e.key === 'Escape') this.collapseMediaAsset()
  }

  collapseMediaAsset () {
    this.expanded = false
    window.removeEventListener('keydown', this.assetKeyHandler)
  }

  invalidVideoStimulus () {
    this.$emit('invalid-youtube-url')
  }
}
